import { useEffect, useRef } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { resolveGatewayBackedServiceBaseUrl } from '../../../services/serviceBaseUrl';

const CHAT_SERVICE_URL = resolveGatewayBackedServiceBaseUrl(process.env.REACT_APP_CHAT_SERVICE_URL);
const HEARTBEAT_INTERVAL_MS = 30000;

export default function PresenceHeartbeat() {
  const intervalRef = useRef(null);
  const cancellingRef = useRef(false);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  useEffect(() => {
    if (!isLoggedIn) {
      if (intervalRef.current) {
        window.clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return undefined;
    }

    let cancelled = false;

    const sendHeartbeat = async () => {
      try {
        await axios.post(
          `${CHAT_SERVICE_URL}/api/chat/presence/heartbeat`,
          {},
          { withCredentials: true }
        );
      } catch (error) {
        // ignore transient failures; next tick will retry
      }
    };

    const start = async () => {
      await sendHeartbeat();
      if (!cancelled) {
        intervalRef.current = window.setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);
      }
    };

    start();

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        sendHeartbeat();
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', handleVisibility);
      if (intervalRef.current) {
        window.clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isLoggedIn]);

  useEffect(() => {
    if (!isLoggedIn) {
      cancellingRef.current = false;
      return undefined;
    }

    const handleBeforeUnload = () => {
      if (cancellingRef.current) {
        return;
      }
      cancellingRef.current = true;
      const url = `${CHAT_SERVICE_URL}/api/chat/presence/heartbeat`;
      const headers = { type: 'application/json' };
      try {
        const payload = new Blob([JSON.stringify({})], headers);
        navigator.sendBeacon(url, payload);
      } catch (error) {
        // ignore
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      cancellingRef.current = false;
    };
  }, [isLoggedIn]);

  return null;
}
